import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { message, Popover } from 'antd';
import { Button, Row, Col, Modal, Input, Spin } from 'antd';
import debounce from 'lodash.debounce';
import Pagination from '@/components/pagination';
import { useActivate, useAliveController } from 'react-activation';
import { searchIcon } from '@/constants/static';
import couponApi from '@/api/coupon';
import { couponStatus } from '@/constants/selectOptions';
import { VoucherCouponItem } from '@/typings/allType';
import { handleExportCodes, handleExportUsageData } from '@/utils/publicMethod';
const VoucherCodes = () => {
    const link = useNavigate();
    const [loading, setLoading] = useState(false);
    const [listParams, setListParams] = useState<any>({
        pageNum: 1,
        pageSize: 10,
        couponListType: 'NotStartedActive',
        keyword: '',
    });
    const [tableData, setTableData] = useState<VoucherCouponItem[]>([]);
    const inputChange = e => {
        debouncedSave({ ...listParams, keyword: e.target.value, pageNum: 1 });
    };
    const debouncedSave = useCallback(
        debounce(nextValue => setListParams(nextValue), 1500),
        []
    );
    async function getVouchers() {
        setLoading(true);
        try {
            const res = await couponApi.getVoucherCouponList(listParams);
            setTableData(res.data.records);
            setTotals({ ...res.data.metaData, currentTotal: res.data.total });
        } catch (error: any) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    }
    const handlePageChange = prop => {
        setListParams(state => ({ ...state, pageNum: prop }));
    };
    useEffect(() => {
        getVouchers();
    }, [listParams]);
    const { drop } = useAliveController();
    useActivate(() => {
        drop('CustomerDetails');
    });
    const [totals, setTotals] = useState({ notStartedActiveTotal: 0, expiredAllUsedTotal: 0, currentTotal: 0 });
    const tableTabs = [
        { label: 'Not started, Active', value: 'notStartedActiveTotal', key: 'NotStartedActive' },
        { label: 'Expired, All used', value: 'expiredAllUsedTotal', key: 'ExpiredAllUsed' },
    ];
    const toInfo = (type: number) => {
        link(`/voucher-code-info?st=${type}`);
    };
    const [pauseId, setPauseId] = useState('');
    const [pauseing, setPauseing] = useState(false);
    const pause = async () => {
        setPauseing(true);
        try {
            await couponApi.pauseCoupon('voucher', pauseId);
            setListParams(state => ({ ...state, pageNum: 1 }));
            setPauseId('');
        } catch (error: any) {
            message.error(error);
        } finally {
            setPauseing(false);
        }
    };
    const [visiblePop, setVisiblePop] = useState(-1);
    const formatDate = (s: string, e: string) => {
        if (!s || !e) return '-';
        const startDate = window.utils.formatTimeMDY(s);
        const endDate = window.utils.formatTimeMDY(e);
        if (startDate === endDate) {
            return startDate;
        } else {
            return `${startDate} - ${endDate}`;
        }
    };
    return (
        <>
            <div className="page-main account" id="voucher-codes">
                <div className="select-bar" style={{ columnGap: 10, marginTop: 0 }} id="select-bar">
                    <div className="page-title">Voucher Codes</div>
                    <div style={{ marginLeft: 'auto' }}>
                        <Input
                            className="search-input"
                            placeholder="Search"
                            style={{ width: 250 }}
                            onChange={inputChange}
                            prefix={searchIcon}
                        />
                    </div>
                    <Button
                        type="primary"
                        size="small"
                        className="flex-center"
                        style={{
                            height: 46,
                            width: 152,
                            borderRadius: 8,
                        }}
                        onClick={() => toInfo(0)}
                        icon={<></>}
                    >
                        <img src={require('@/assets/images/add-icon.png')} alt="" />
                        New Code
                    </Button>
                </div>
                <div className="table">
                    <div className="tabs-table">
                        {tableTabs.map(t => {
                            return (
                                <div
                                    className={`tabs-table-item ${
                                        t.key === listParams.couponListType ? 'tabs-table-item-active' : ''
                                    }`}
                                    key={t.value}
                                    onClick={() =>
                                        setListParams(state => ({
                                            ...state,
                                            pageNum: 1,
                                            couponListType: t.key,
                                        }))
                                    }
                                >
                                    {t.label} ({totals[t.value] || 0})
                                </div>
                            );
                        })}
                    </div>
                    {loading ? (
                        <div className="data_loading flex-center">
                            <Spin />
                        </div>
                    ) : (
                        <>
                            {tableData.length ? (
                                <>
                                    <div className="table-th">
                                        <Row>
                                            <Col span={7}>Title</Col>
                                            <Col span={5}>Validity</Col>
                                            <Col span={3}>Quantity</Col>
                                            <Col span={4}>Redemption Count</Col>
                                            <Col span={3}>Status</Col>
                                            <Col span={2}>Options</Col>
                                        </Row>
                                    </div>
                                    {tableData.map((item, index) => (
                                        <Row className="table-tr" key={item.voucherId}>
                                            <Col span={7}>
                                                {item.isFixedCode && (
                                                    <span style={{ fontFamily: 'SemiBold', color: '#052588' }}>
                                                        [{item.discountCode}]
                                                    </span>
                                                )}{' '}
                                                {item.voucherName}
                                            </Col>
                                            <Col span={5}>
                                                {item.validityType === 'permanentlyValid'
                                                    ? 'Permanently valid'
                                                    : formatDate(item.beginDate, item.endDate)}
                                            </Col>
                                            <Col span={4}>{item.isUnlimited ? 'Unlimited' : item.quantity}</Col>
                                            <Col span={3}>{item.redemptionCount}</Col>
                                            <Col
                                                span={3}
                                                style={{
                                                    color: (item.status && couponStatus[item.status]?.color) || '',
                                                }}
                                            >
                                                {item.status}
                                            </Col>
                                            <Col span={2}>
                                                <Popover
                                                    open={visiblePop === index}
                                                    onOpenChange={v => setVisiblePop(v ? index : -1)}
                                                    placement="bottomRight"
                                                    content={
                                                        <div className="view-more" style={{ width: 140 }}>
                                                            <div
                                                                onClick={() => {
                                                                    setVisiblePop(-1);
                                                                    link(
                                                                        `/coupon-detail?st=voucher&stv=${window.btoa(
                                                                            item.voucherId
                                                                        )}`
                                                                    );
                                                                }}
                                                            >
                                                                View details
                                                            </div>
                                                            <div
                                                                onClick={() =>
                                                                    handleExportUsageData(
                                                                        'voucher',
                                                                        item.voucherId,
                                                                        item.voucherName
                                                                    )
                                                                }
                                                            >
                                                                Export Usage Data
                                                            </div>
                                                            {!item.isFixedCode && (
                                                                <div
                                                                    onClick={() =>
                                                                        handleExportCodes(
                                                                            item.voucherId,
                                                                            item.voucherName
                                                                        )
                                                                    }
                                                                >
                                                                    Export Code
                                                                </div>
                                                            )}
                                                            {(item.status === 'Active' ||
                                                                item.status === 'Not Started') && (
                                                                <div onClick={() => setPauseId(item.voucherId)}>
                                                                    Pause
                                                                </div>
                                                            )}
                                                        </div>
                                                    }
                                                >
                                                    <img
                                                        style={{
                                                            width: 24,
                                                            height: 24,
                                                            cursor: 'pointer',
                                                            textAlign: 'right',
                                                        }}
                                                        src={require('@/assets/images/view-more.png')}
                                                        alt=""
                                                    />
                                                </Popover>
                                            </Col>
                                        </Row>
                                    ))}
                                    <Pagination
                                        total={totals.currentTotal}
                                        pageChange={handlePageChange}
                                        pageNo={listParams.pageNum}
                                    />
                                </>
                            ) : (
                                <div className="no-data flex-center">No data</div>
                            )}
                        </>
                    )}
                </div>
            </div>
            <Modal
                width={440}
                maskClosable={false}
                centered={true}
                open={pauseId ? true : false}
                closeIcon={<img src={require('@/assets/images/Icons_Cross.png')} style={{ width: 24, height: 24 }} />}
            >
                <div className="modal-title" style={{ marginTop: 37 }}>
                    Expire coupons?
                </div>
                <div className="modal-tip tip-font-16">
                    All unused coupons will immediately expire, and this action cannot be undone.
                    <br />
                    <br />
                    Coupons that have already been redeemed will remain valid and cannot be reversed.
                </div>
                <div className="flex-center" style={{ marginTop: 30, columnGap: 20 }}>
                    <Button style={{ width: 138, height: 46 }} onClick={() => setPauseId('')} className="cancel-btn">
                        Cancel
                    </Button>
                    <Button style={{ width: 138, height: 46 }} danger type="primary" loading={pauseing} onClick={pause}>
                        Pause
                    </Button>
                </div>
            </Modal>
        </>
    );
};

export default VoucherCodes;
